<template>
  <v-text-field
    v-bind="$attrs"
    :type="show ? 'text' : 'password'"
    @click:append="show = !show"
    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  name: 'BasePasswordField',
  data() {
    return {
      show: false,
    };
  },
};
</script>
